import { AutogenModelUsersPowerbrokerTruckstop, AutogenRowUsersPowerbrokerTruckstop } from "./autogen/AutogenModelUsersPowerbrokerTruckstop";

export class ModelUsersPowerbrokerTruckstop extends AutogenModelUsersPowerbrokerTruckstop<RowUsersPowerbrokerTruckstop> {
	constructor() {
		super(RowUsersPowerbrokerTruckstop);
	}
}

export class RowUsersPowerbrokerTruckstop extends AutogenRowUsersPowerbrokerTruckstop {
}